<template>
  <div>
    <div>
      <!-- item list -->
      <div class="grid gap-6 grid-cols-2 md:grid-cols-4 mb-8 lg:mb-24">
        <div v-if="!loading && items.length === 0" v-html="noResultText" />

        <article v-for="(item, index) in items"
                 :key="item.id"
                 class="bg-white"
        >
          <a
            :href="item.url"
            class="group"
            @click="onItemClick(item.hitId, index + 1)"
          >
            <Picture
              v-bind="item.image"
              class="block relative h-0 pb-9/16 overflow-hidden"
              lazy
              img-class="absolute top-0 left-0 w-full h-full object-cover transform transition-transform duration-300 group-hover:scale-105"
              :alt="item.name"
              width="375"
              height="211"
            />

            <div class="p-2 md:p-4">
              <div class="text-2xs md:text-xs uppercase md:normal-case">{{ item.description }}</div>
              <div class="text-2xs md:text-xs uppercase md:normal-case">{{ item.cookingTime }}</div>
              <div class="font-semibold text-sm lg:text-lg">{{ item.name }}</div>
            </div>
          </a>
        </article>
      </div>

      <!-- Search more -->
      <div
        v-if="!loading && !allItemsLoaded"
        class="text-center"
      >
        <a
          v-if="loadMoreButton && loadMoreButton.isEnabled"
          :href="loadMoreButton.nextPageUrl"
          class="inline-flex"
          @click.prevent="searchMore"
        >
          <span
            class="btn-red md:hidden btn btn-sm rounded-md"
            v-text="loadMoreButton.text"
          />
          <span
            class="btn-red hidden md:inline-block btn rounded-md"
            v-text="loadMoreButton.text"
          />
        </a>
        <template v-else>
          <button
            class="btn-red md:hidden btn btn-sm rounded-md"
            @click="searchMore"
          >
            {{ loadMoreButtonText }}
          </button>
          <button
            class="btn-red hidden md:inline-block btn rounded-md"
            @click="searchMore"
          >
            {{ loadMoreButtonText }}
          </button>
        </template>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="text-center">
      <div class="spinner spinner-lg spinner-bg-primary-light" />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

import Picture from '@/components/Picture.vue'
import searchFactory from '@/compositions/search/SearchFactory'
import searchConfig from '@/compositions/search/SearchConfiguration'
import searchQueryState from '@/compositions/search/SearchQuery'
import api from '@/api'

export default {
  components: {
    Picture
  },
  props: {
    loadMoreButton: {
      type: Object,
      default: null
    }
  },
  setup() {
    const { getActiveConfig } = searchConfig.searchConfigurationUse()
    const {
      items, totalCount, searchMore, trackId, loading, allItemsLoaded
    } = searchFactory.useSearchResult()
    const { activeTerms } = searchQueryState.searchQueryUse()

    function onItemClick(hitId, position) {
      api.trackItemClick({
        searchType: 'recipe',
        trackId: trackId.value,
        hitId,
        terms: encodeURIComponent(activeTerms.value),
        position
      })
    }

    return {
      allItemsLoaded,
      loading,
      items,
      totalCount,
      noResultText: computed(() => getActiveConfig().translations.noResultHtml),
      loadMoreButtonText: computed(() => getActiveConfig().translations.loadMoreButtonText),

      searchMore,
      onItemClick
    }
  }
}
</script>
